/*
 * File: ZoominfoCompanies.tsx
 * Project: a-a
 * File Created: Tuesday, 4th November 2025 11:55:41 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 14th November 2025 6:51:10 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import zeplinColor from '../../../../theme/Color';
import ZoominfoCompaniesCard from './ZoominfoCompaniesCard';
import { Link, useLocation } from 'react-router-dom';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import InfiniteScroll from 'react-infinite-scroll-component';

const ZoominfoCompanies = ({ loading, data }: { loading: boolean; data: any }) => {
  const location = useLocation();
  // const [loading, setLoading] = useState(false);
  // const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(false);

  // const getCompanySimilar = async (id = '', page = 1) => {
  //   try {
  //     setLoading(true);
  //     const res = await ZoomInfoService.getCompanySimilar(id, page);
  //     console.log(res);
  //     setData(res?.data?.similar);
  //     setPageNumber((prev) => prev + 1);
  //     setTotal(res?.data?.pagination?.total);
  //   } catch (err) {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleClose = () => {
    setError(false);
  };
  // useEffect(() => {
  //   getCompanySimilar(location?.pathname.split('/')[2] || '');
  // }, []);
  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 350px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
          overflowY: 'auto',
          //   height: 'calc(100vh - 400px)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
          }}
        >
          <Typography variant='responsiveHeading3'>Similar companies</Typography>
          <InfiniteScroll
            dataLength={data?.length || 0}
            loader={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // visibility: 'hidden',
                }}
              >
                <h4></h4>
              </Box>
            }
            next={() => {
              // console.log('next');
              // getCompanySimilar(location?.pathname.split('/')[2] || '', pageNumber);
              // next(true);
            }}
            hasMore={data?.data?.length < total}
            height={'calc(100vh - 350px)'}
            // height={'100vh'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
              // paddingBottom: '1rem',
              // overflowY: 'auto',
            }}
          >
            {!data ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1,
                  height: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No similar companies
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(2,1fr)',
                    xl: 'repeat(3,1fr)',
                    // xs: 'repeat(auto-fill, minmax(250px, 1fr))', // Responsive columns
                    // sm: 'repeat(auto-fill, minmax(270px, 1fr))',
                    // md: 'repeat(auto-fill, minmax(280px, 1fr))',
                    // lg: 'repeat(auto-fill, minmax(290px, 1fr))',
                    // xl: 'repeat(auto-fill, minmax(300px, 1fr))',
                  },
                  gap: '24px',
                  overflowY: 'auto',
                  gridAutoRows: 'min-content', // Make rows only as tall as content
                  gridAutoFlow: 'row',
                  flex: 1,
                }}
              >
                {loading
                  ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((val) => (
                      <ZoominfoCompaniesCard val={val} loading={loading} />
                    ))
                  : data?.map((val: any) => (
                      <Link
                        to={`/zoominfo/${val?.id ?? ''}`}
                        // onClick={() => console.log('data')}
                        style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                      >
                        <Box
                          sx={{
                            borderRadius: '14px',
                            padding: '12px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            backgroundColor: zeplinColor.Neutral3,
                            ':hover': {
                              backgroundColor: zeplinColor.Neutral4,
                            },
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '12px',
                              alignItems: 'center',
                            }}
                          >
                            <Box
                              sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '8px',
                                backgroundColor: zeplinColor.Neutral1,
                              }}
                            >
                              <img
                                src={val?.logo}
                                width='48px'
                                height='48px'
                                alt='industry'
                                style={{ objectFit: 'contain', borderRadius: '8px' }}
                                onError={(e) => {
                                  e.currentTarget.onerror = null;
                                  e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                                }}
                              />
                            </Box>
                            <Typography sx={{ fontSize: '18px' }} color={zeplinColor.BasicBlack}>
                              {val?.name}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              width: '24px',
                              height: '24px',
                              backgroundColor: zeplinColor.Neutral10,
                              borderRadius: '50px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={() => {}}
                          >
                            <img src='/assets/arrow-next-white.svg' alt='arrow-next' />
                          </Box>
                        </Box>
                      </Link>
                    ))}
              </Box>
            )}
          </InfiniteScroll>
        </Box>
      </Box>
    </Box>
  );
};

export default ZoominfoCompanies;
